import { useTimers } from '../store/timers'
import { Timer } from '../types/timers'
import { storeToRefs } from 'pinia'

export const useChildTimerRules = () => {
  const { getAllParentTimers } = storeToRefs(useTimers())

  //
  const sumChildrenNotGreaterThanParent = (
    data: Partial<{ newStart: Date; newEnd: Date }>,
    timer: Timer | null
  ) => {
    //first escape all edge cases where this rule would not apply
    if (!timer) {
      return true
    } else if (!timer.end_time) {
      return true
    } else if (!timer.children || timer.children.length == 0) {
      return true
    } else {
      //actual logic here
      //get total in ms of children
      const totalTimeChildrenMS = timer.children.reduceRight((acc, curr) => {
        //cannot get to this point w/o having ended the child timer
        //b/c a parent cannot be ended w/o ending its child
        const total = new Date(curr.end_time!).getTime() - new Date(curr.start_time).getTime()
        return total + acc
      }, 0)
      const totalTimeParentMS =
        new Date(data.newEnd ? data.newEnd : timer.end_time).getTime() -
        new Date(data.newStart ? data.newStart : timer.start_time).getTime()
      return totalTimeParentMS >= totalTimeChildrenMS
    }
  }

  const notBeforeStart = (data: { childStart: Date; childEnd: Date }, timer: Timer | null) => {
    if (!timer) {
      return false
    } else if (!timer.end_time) {
      return false
    } else if (!timer.children || timer.children.length == 0) {
      return false
    } else {
      return !!(data.childEnd.getTime() >= data.childStart.getTime())
    }
  }

  const newSumChildrenNotGreaterThanParent = (
    newTimes: {
      start_time: Timer['start_time']
      end_time: NonNullable<Timer['end_time']>
    },
    parentIndex: number,
    childIndex: number
  ) => {
    const parent = getAllParentTimers.value[parentIndex]
    // Find the current parent duration and what would be the new total child duration
    // Currently, since this is editing a child timer, the end time should always exist
    const parentDuration = parent.end_time!.getTime() - parent.start_time.getTime()
    const newSumChildren = parent.children.reduceRight(
      (acc, curr, index) =>
        acc +
        (index === childIndex
          ? newTimes.end_time.getTime() - newTimes.start_time.getTime()
          : curr.end_time!.getTime() - curr.start_time.getTime()),
      0
    )
    // Make sure that the parent timer has the same or a greater duration than the proposed sum of child times
    return parentDuration >= newSumChildren
  }

  return {
    sumChildrenNotGreaterThanParent,
    notBeforeStart,
    newSumChildrenNotGreaterThanParent,
  }
}
